import { render, staticRenderFns } from "./~EmailMarketingProvider.vue?vue&type=template&id=abda1372&scoped=true"
import script from "./~EmailMarketingProvider.vue?vue&type=script&lang=js"
export * from "./~EmailMarketingProvider.vue?vue&type=script&lang=js"
import style0 from "./~EmailMarketingProvider.vue?vue&type=style&index=0&id=abda1372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "abda1372",
  null
  
)

export default component.exports